import styled from "styled-components";

export const Header = styled.div`
  display: none;
`;

export const Logo = styled.div`
  border: 1px solid var(--app-line);
  border-radius: 10px;
  background: #fff url(${(props) => props.bgImage}) center no-repeat;
  background-size: contain;
  width: 100px;
  height: 100px;

  /* @media (max-width: 576px) {
    width: 80px;
    height: 80px;
  } */
`;

export const LogoLink = styled.a`
  flex: 0 0 auto;
  border-radius: 10px;
  transition: transform 180ms ease, box-shadow 180ms ease;

  &:hover,
  &:focus-visible {
    transform: translateY(-4px);
    box-shadow: 0 10px 24px rgba(31, 37, 32, 0.14);
  }

  &:focus-visible {
    outline: 3px solid rgba(242, 100, 60, 0.4);
    outline-offset: 3px;
  }

  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }
`;

export const Button = styled.button`
  padding: 0 26px;
  min-height: 42px;
  font-family: "DM Sans", Arial, sans-serif;
  font-weight: 700;
  font-size: 13px;
  border: 1px solid
    ${({ active, primary, $success }) =>
      active || primary
        ? "var(--app-ink)"
        : $success
        ? "var(--app-ink)"
        : "var(--app-line)"};
  border-radius: 7px;
  color: var(--app-ink);
  background-color: ${({ active, primary, $success }) =>
    $success
      ? "var(--app-herb)"
      : active || primary
      ? "var(--app-ink)"
      : "transparent"};
  color: ${({ active, primary, $success }) =>
    active || primary ? "#fff" : "var(--app-ink)"};
  white-space: nowrap;
  transition: border-color 220ms ease, box-shadow 220ms ease;

  &:hover:not([disabled]):not([aria-disabled="true"]) {
    border-color: var(--app-ink);
    box-shadow: 0 10px 24px rgba(31, 37, 32, 0.14);
  }
  &:focus-visible {
    outline: 3px solid rgba(242, 100, 60, 0.4);
    outline-offset: 2px;
  }
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
  &[aria-disabled="true"] {
    opacity: 0.5;
    cursor: help;
  }
`;

export const LinkButton = styled.button`
  display: inline;
  padding: 6px 0;
  border: 0;
  border-bottom: 1px solid currentColor;
  border-radius: 0;
  color: var(--app-ink);
  background: transparent;
  font-family: "DM Sans", Arial, sans-serif;
  font-size: 0.82rem;
  font-weight: 600;
  line-height: 1.35;
  text-underline-offset: 3px;
  cursor: pointer;
  transition: border-color 140ms ease, color 140ms ease;

  &:hover {
    color: var(--app-muted);
    border-bottom-color: var(--app-muted);
  }

  &:focus-visible {
    outline: 3px solid rgba(242, 100, 60, 0.4);
    outline-offset: 3px;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const StoreStatusButton = styled.button`
  width: fit-content;
  display: inline-flex;
  align-items: center;
  gap: 7px;
  margin: 0;
  padding: 7px 10px;
  border: 1px solid var(--app-line);
  border-radius: 7px;
  color: var(--app-ink);
  background: var(--app-control);
  font-family: "DM Sans", Arial, sans-serif;
  font-size: 0.8rem;
  line-height: 1;
  cursor: pointer;
  transition: border-color 220ms ease;

  &::before {
    content: "";
    width: 7px;
    height: 7px;
    flex: 0 0 auto;
    border-radius: 50%;
    background: ${({ $open }) =>
      $open ? "var(--app-herb)" : "var(--app-oven)"};
    box-shadow: 0 0 0 2px var(--app-plate);
  }

  small {
    padding-left: 7px;
    border-left: 1px solid var(--app-line);
    color: var(--app-muted);
    font-size: 0.72rem;
  }

  &:hover {
    border-color: var(--app-ink);
  }

  &:focus-visible {
    outline: 3px solid rgba(242, 100, 60, 0.4);
    outline-offset: 2px;
  }
`;

export const OpeningHoursContent = styled.div`
  margin-top: 12px;
  padding-top: 20px;
`;

export const OpeningHoursEmpty = styled.div`
  display: grid;
  justify-items: center;
  gap: 12px;
  padding: 12px 20px 4px;
  text-align: center;

  p {
    margin: 0;
    color: var(--app-muted);
    font-size: 0.9rem;
    font-weight: 400;
    line-height: 1.5;
  }
`;

export const BrandContactRow = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px 12px;
`;

export const PhoneLink = styled.a`
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 2px 0;
  font-family: "DM Sans", Arial, sans-serif;
  font-size: 0.86rem;
  font-weight: 600;
  white-space: nowrap;

  &:hover {
    text-decoration: underline;
    text-underline-offset: 3px;
  }
  &:focus-visible {
    outline: 3px solid rgba(242, 100, 60, 0.4);
    outline-offset: 2px;
  }
`;

export const ClickableDiv = styled.div`
  cursor: pointer;
  text-decoration: underline;
  text-underline-offset: 3px;
`;
